const sequence = (...functions: any[]) => (initialValues?: any) =>
  functions.slice(1).reduce((soFar, f) => soFar.then(f), functions[0](initialValues));

export default sequence;
